import * as React from "react";
import { Card, CardContent, Box, CardActionArea, useTheme } from "@mui/material";
import { CervinoHeaderText } from "../typography/CervinoHeaderText";
import CervinoText from "../typography/CervinoText";
import SMButtonBrown from "../navigation/SMButtonBrown";

export function PromoCtaCard({
                                 icon,
                                 imageSrc,
                                 imageAlt = "",
                                 title,
                                 description,
                                 ctaLabel,
                                 onCtaClick,
                                 href,
                                 onCardClick,
                                 maxWidth,
                                 cardWidth,
                                 minHeight,
                                 contentSx,
                                 sx,
                                 slots,
                             }) {
    const Header = slots?.header;
    const Footer = slots?.footer;
    const theme = useTheme();

    const Media = () => {
        if (imageSrc) {
            return (
                <Box
                    component="img"
                    src={imageSrc}
                    alt={imageAlt}
                    sx={{
                        width: 64,
                        height: 64,
                        objectFit: "contain",
                        display: "block",
                    }}
                />
            );
        }
        if (icon) {
            return (
                <Box sx={{ fontSize: { xs: 44, sm: 56, md: 64 }, lineHeight: 0 }}>
                    {icon}
                </Box>
            );
        }
        return null;
    };

    const CtaButton = (
        <SMButtonBrown
            onClick={onCtaClick}
            component={href ? "a" : "button"}
            href={href}
            sx={{
                textTransform: "uppercase",
                fontSize: { xs: "0.9rem", sm: "1.1rem", md: "1.2rem", lg: "1.4rem" },
                width: { xs: "100%", sm: "auto" }, // optional: full width on xs
                alignSelf: "center",
            }}
        >
            {ctaLabel}
        </SMButtonBrown>
    );

    const Inner = (
        <CardContent
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                ...contentSx,
            }}
        >
            {/* Top / Header */}
            {Header ? (
                <Header />
            ) : (
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                    <Media />
                </Box>
            )}

            {/* Body grows to fill available space */}
            <Box sx={{ flexGrow: 1 }}>
                {title ? (
                    <CervinoHeaderText
                        sx={{
                            fontSize: { xs: "1.4rem", sm: "1.6rem", md: "2rem", lg: "2.4rem" },
                        }}
                        color={theme.palette.primary.main}
                    >
                        {title}
                    </CervinoHeaderText>
                ) : null}

                {description ? (
                    <CervinoText
                        sx={{
                            fontSize: { xs: "1rem", sm: "1.2rem", md: "1.2rem", lg: "1.4rem" },
                            fontWeight: 600,
                        }}
                    >
                        {description}
                    </CervinoText>
                ) : null}
            </Box>

            {/* Footer pinned to bottom */}
            <Box sx={{ pt: 1 }}>
                {Footer ? <Footer /> : CtaButton}
            </Box>
        </CardContent>
    );

    return (
        <Card
            elevation={0}
            sx={{
                width: cardWidth || { xs: 180, sm: 220, md: 240, lg: 320 },
                maxWidth,
                minWidth: 0,
                height: "100%",
                minHeight: minHeight || { xs: 280, sm: 300, md: 320, lg: 360, xl: 370 }, // aligns CTAs
                borderRadius: 4,
                border: "1px solid",
                borderColor: "divider",
                overflow: "hidden",
                ...sx,
            }}
        >
            {onCardClick ? (
                <CardActionArea sx={{ height: "100%" }} onClick={onCardClick}>
                    {Inner}
                </CardActionArea>
            ) : (
                Inner
            )}
        </Card>
    );
}
